import React from "react";
import { Routes, Route } from "react-router-dom";
import CadastrarEmpresa from "../cadastro/empresa/cadastrar/CadastrarEmpresa";
import Login from "../login/Login";
import { AlertaSucesso } from '../modal/AlertaSucesso.js';
import AlterarSenha from "../alterar/senha/AlterarSenha";
import AlterarSenhaLink from "../alterar/senha/AlterarSenhaLink";
import TrocaSenhaProducao from "../alterar/senha/TrocaSenhaProducao";
export default function RotasLogin(props){
    return(
            <Routes>
                <Route path="*" element={<Login setToken={props.setToken}/>}/>
                <Route path="/cadastrar-empresa" element={<CadastrarEmpresa/>}/>

                <Route path="/alterar-senha" element={<AlterarSenha/>}/>

                <Route path='/troca-senha/:key' element={<AlterarSenhaLink/>}/>
                <Route path='/troca-senha-producao/:token' element={<TrocaSenhaProducao/>}/>

                {/* alertas */}
                <Route path="/alerta-sucesso/:texto&:pagina" element={<AlertaSucesso/>}/>
                {/* fim alertas */}
            </Routes>
    )
}